export default __webpack_public_path__ + "static/media/Bracers of Haloga.95126db0.jpg";